import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Fastly extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M13.25475,11.15775 L12.867,10.77 L10.885125,12.49725 C10.7819772,12.4605738 10.673222,12.442173 10.56375,12.442875 C10.0305,12.442875 9.594,12.891375 9.594,13.436625 C9.594,13.987875 10.0305,14.430375 10.56375,14.430375 C11.097,14.430375 11.5335,13.981875 11.5335,13.436625 C11.5335,13.3335 11.5155,13.230375 11.491125,13.139625 L13.25475,11.15775 Z M21.11475,18.872625 L21.1125,2.896875 L15.975,2.896875 L15.975,4.393875 C14.9205,3.7575 13.7385,3.309 12.4875,3.07275 L12.5175,3.07275 L12.5175,1.30275 L13.141875,1.30275 L13.141875,0 L7.969875,0 L7.969875,1.303125 L8.59425,1.303125 L8.59425,3.073125 L8.630625,3.073125 C3.721125,3.97575 0,8.2725 0,13.448625 C0,19.275 4.725,24 10.55175,24 C12.53925,24 14.400375,23.44875 15.988125,22.491 L16.91475,24 L22.33875,24 L22.33875,18.8625 L21.114375,18.8625 L21.11475,18.872625 Z M10.86975,18.8625 L10.86975,18.2565 L10.2585,18.2565 L10.2585,18.8565 C7.50075,18.699 5.301,16.480875 5.1555,13.719 L5.7675,13.719 L5.7675,13.107 L5.1615,13.107 C5.325,10.367625 7.519125,8.1735 10.2585,8.016 L10.2585,8.622 L10.8705,8.622 L10.8705,8.016 C13.5735,8.1615 15.7455,10.2825 15.9855,12.9555 L15.9855,13.13175 L15.3675,13.13175 L15.3675,13.74375 L15.9855,13.74375 L15.9855,13.913625 C15.75525,16.59225 13.5735,18.713625 10.8705,18.859125 L10.86975,18.8625 Z" />
      </svg>
    );
  }
}

export default Fastly;
